import { useMemo } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { LocalizedText } from '@mews/framework';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { ColumnFilterType, IconButton, IconName } from '@optimus-web/core';
import { GeneralEnterpriseWithCityName } from '../types';
import { DeletePropertiesWrapper } from '../DeletePropertiesWrapper';

const columnHelper = createColumnHelper<GeneralEnterpriseWithCityName>();

interface UseColumnsParams {
    propertyGroup: PortfolioEnterpriseGroupResult;
    onDeleteSuccess?: () => void;
}

export const useColumns = ({ propertyGroup, onDeleteSuccess }: UseColumnsParams) =>
    useMemo(
        () => [
            columnHelper.accessor('name', {
                header: () => <LocalizedText textKey={TextKey.Name} />,
                enableSorting: true,
                enableColumnFilter: true,
                meta: {
                    filtersType: ColumnFilterType.String,
                },
            }),
            columnHelper.accessor('cityName', {
                header: () => <LocalizedText textKey={TextKey.City} />,
                cell: (props) => props.getValue(),
                enableSorting: true,
                enableColumnFilter: true,
                meta: {
                    filtersType: ColumnFilterType.String,
                },
            }),

            columnHelper.display({
                id: 'actions',
                meta: { align: 'end' },
                cell: (props) => (
                    <RowActions
                        propertyGroup={propertyGroup}
                        selectedProperty={props.row.original}
                        onSuccess={onDeleteSuccess}
                    />
                ),
            }),
        ],
        [propertyGroup, onDeleteSuccess]
    );

interface RowActionsProps {
    propertyGroup: PortfolioEnterpriseGroupResult;
    selectedProperty: GeneralEnterpriseWithCityName;
    onSuccess?: () => void;
}

const RowActions = ({ propertyGroup, selectedProperty, onSuccess }: RowActionsProps) => (
    <DeletePropertiesWrapper
        propertyGroup={propertyGroup}
        selectedProperties={[selectedProperty]}
        onSuccess={onSuccess}
        renderButtonComponent={(onClick) => (
            <IconButton variant="ghost" icon={IconName.Delete} onClick={onClick} size="small" type="submit" />
        )}
    />
);
